import React, { useState } from 'react'
import ReactSelect from '../../../Components/New/Select/ReactSelect'
import { formatReactSelectOptions } from '../../../Utils/commonFunctions'
import { IconInfo } from '../../../assests/icons/DrawerIcons'
import { useAppDispatch, useAppSelector } from '../../../ReduxTool/store/hooks'
import { NewModal } from '../../../Components/New/Modal/NewModal'
import { setModalHeaderFooter } from '../../../ReduxTool/Slice/CommonReducers/CommonReducers'
import { IconSave } from '../../../assests/icons/MapToolsIcons'
import { ModalId } from '../../../Components/New/Modal/ProfileModal/Const'

const Language = ({isEditing}:{isEditing:boolean}) => {
  const [language,setLanguage] = useState({language:{ label: "English", value: "English" },})
  const languageList = [{ label: "English", value: "English" }, { label: "Spanish", value: "Spanish" }, { label: "Arab", value: "Arab" }]

  const handleChange = async (props: any, selectedOption?: any) => {
    let { name, value } = props?.target ?? props;
    if (selectedOption) {   name = selectedOption.name;    value = props;   };
    setLanguage(prev => ({ ...prev, [name]: value }))
    }

  return (
    <div>
      <ReactSelect handleInputChange={()=>{}} options={formatReactSelectOptions(languageList, { labelKey: "label", valueKey: "value" }, false)} onChange={handleChange} value={language.language} id={"language"} name={"language"} labelname="Select Language" closeMenuOnSelect={true} isUpload={false} isrequired={true} icon={<IconInfo />} disabled={true} />
    </div>
  )
}

function UserLanguageModal() {
     const dispatch = useAppDispatch();
    const { modalid } = useAppSelector((state) => state.commonReducers.modal);
  
    const closeModal = () => { 
            dispatch(setModalHeaderFooter({title: "", btnTxt: "", secondaryBtnTxt: "", isheader: false,modalid: "" }));
        };

  return (<>
        {  modalid === ModalId.UserLanguage &&  <NewModal height={"fit-content"} maxheight={"none"} primaryBtnDisabled modalSize="md" name="Units & Region" btnName="Save" onClick={()=>{}} setIsCLose={closeModal} isAbleCLick={false}  
           primarylefticon={<IconSave />} isFooterRequired={false}   >
          <Language isEditing={false} />
           </NewModal>}
        </>)
}

export default UserLanguageModal